import { action, observable } from 'mobx';

import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { SerializedData, Store } from 'bernie-core';

export class AdvertisingStore extends Store {
  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public static DEFAULTS = {
    adsloader: '',
    adsloaderes5: '',
    triggeredPageName: undefined
  };

  @observable
  public adsloader: string;
  @observable
  public adsloaderes5: string;
  @observable
  public triggeredPageName: string;

  @action
  public trigger(pageName: string) {
    this.triggeredPageName = pageName;
  }
}
